/**
 * Store referral code in session storage for processing after authentication
 */
export function storeReferralCodeForProcessing(referralCode: string): void {
    if (referralCode && referralCode.trim()) {
        sessionStorage.setItem('pendingReferralCode', referralCode.trim().toUpperCase())
    }
}

/**
 * Retrieve and clear stored referral code
 */
export function retrieveStoredReferralCode(): string | null {
    return sessionStorage.getItem('pendingReferralCode')
}

export function clearStoredReferralCode() {
    sessionStorage.removeItem('pendingReferralCode')
}

/**
 * Extract referral code from URL parameters
 */
export function extractReferralCodeFromUrl(searchParams: URLSearchParams): string | null {
    const code = searchParams.get('ref') || searchParams.get('referral') || searchParams.get('referralCode')
    if (code) {
        // Normalize the code: uppercase, alphanumeric only, max 8 characters
        return code.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 8)
    }
    return null
}

/**
 * Generate referral link with the given code
 */
export function generateReferralLink(referralCode: string, baseUrl?: string): string {
    const base = baseUrl || window.location.origin
    return `${base}/referral?ref=${referralCode}`
}